import {
  AccessRequest,
  AccountCreateAccessRequest,
} from '@/api/__generated__/webApi';
import { apiClient } from '@/client/ApiClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getError } from '../common/error-handlers';
import { errorHandler } from '../errorHandler';
import { notifyActions } from '../notifications/slice';

const ACESSES_REQUESTS_PREFIX = 'api/accesses/requests';

const ACCESSES_REQUESTS_CREATE = `${ACESSES_REQUESTS_PREFIX}/create`;

export const createRequestAccess = createAsyncThunk(
  ACCESSES_REQUESTS_CREATE,
  async (
    body: AccountCreateAccessRequest,
    { requestId, rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await apiClient.post<AccessRequest>(
        ACCESSES_REQUESTS_CREATE,
        body
      );
      return data;
    } catch (e) {
      const error = getError(e);
      errorHandler(error);
      dispatch(
        notifyActions.showNotifications([
          { id: requestId, type: 'error', text: error },
        ])
      );
      return rejectWithValue(error);
    }
  }
);
